import Drawer from '@/common/components/Drawer/Drawer';
import { LelyRadioButton } from '@/common/components';
import { SettingsDrawerProps } from '../ManageSettings';
import { useAppSelector } from '@/reducers/rootReducer';
import { translationSelectors } from '@/reducers/translationSlice';
import { Box, RadioGroup, Typography } from '@mui/material';
import { getLanguageImpactMessage } from './languageImpact';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateLanguage } from '@/reducers/translationSlice';

const ManageLanguageDrawer = ({
  open,
  onClose,
  onCloseAll,
}: SettingsDrawerProps) => {
  const dispatch = useDispatch();
  const savedLanguage = useAppSelector(
    translationSelectors.selectPreferredLanguageCode,
  );
  const [draftLanguage, setDraftLanguage] = useState(savedLanguage);
  const availableLanguages = useAppSelector(
    translationSelectors.selectAvailableLanguages,
  );

  const handleLanguageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDraftLanguage(event.target.value);
  };

  useEffect(() => {
    if (open) setDraftLanguage(savedLanguage);
  }, [open, savedLanguage]);

  const hasUnsavedChanges = draftLanguage !== savedLanguage;
  const languageImpactMessage = getLanguageImpactMessage(draftLanguage);

  const handleLanguageApply = () => {
    dispatch(updateLanguage({ language: draftLanguage }));
    onClose();
  };

  return (
    <Drawer
      title="Language"
      open={open}
      onApply={handleLanguageApply}
      onClose={onClose}
      onCloseAll={onCloseAll}
      showFooter={true}
      showBackButton={true}
      invisibleBackdrop
      hasUnsavedChanges={hasUnsavedChanges}
    >
      <Box display="flex" flexDirection="column" gap={2}>
        <Typography
          variant="body2"
          color="text.primary"
          data-testid="language-impact-message"
        >
          {languageImpactMessage}
        </Typography>
        <RadioGroup value={draftLanguage} onChange={handleLanguageChange}>
          {availableLanguages.map((language) => (
            <LelyRadioButton
              key={language.code}
              value={language.code}
              label={language.Language}
              data-testid="language-radio-button"
            />
          ))}
        </RadioGroup>
      </Box>
    </Drawer>
  );
};

export default ManageLanguageDrawer;
